import React from "react";
import * as apiUtils from "../../../util/apiUtil";
import Loading from "../../../component/loading/Loading";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import * as inquiryAction from "../store/inquiry";
import InquiryDetailTable from "../component/InquiryDetailTable";

class InquiryDetailContainer extends React.Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.ajaxInquiry = this.ajaxInquiry.bind(this);
        this.handleDelete = this.handleDelete.bind(this);

        this.state = {
            loading: false,
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.loading !== nextState.loading
            || this.props.detailInquiry !== nextProps.detailInquiry
        )
    }

    componentDidMount() {
        this.ajaxInquiry();
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }


    ajaxInquiry() {
        const { InquiryAction, id } = this.props;
        apiUtils.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/inquiry/" + id,
            method: apiUtils.requestMethod.GET,
            isFile: false,
            success: (result) => {
                InquiryAction.setDetailInquiry(result);
            }
        });
    }

    handleDelete() {
        if(!window.confirm("1:1 문의를 삭제하시겠습니까?")) return;

        const { id } = this.props;
        apiUtils.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/inquiry/" + id + "/delete",
            method: apiUtils.requestMethod.POST,
            isFile: false,
            success: (result) => {
                alert("1:1 문의가 삭제되었습니다.");
                window.location.href="/announce/inquiry"
            }
        });
    }


    render() {
        const { loading } = this.state;
        const { detailInquiry, id } = this.props;
        return (
            <>
                <Loading loading={loading}/>
                <section className='container-xxl inquiry-list'>
                    <h2 className='fs-4'>답변 확인하기</h2>
                    <div className='card'>
                        <div className='card-body'>
                            <InquiryDetailTable
                                inquiry={detailInquiry}
                                uid={id}
                                handleDelete = {this.handleDelete}
                            />
                        </div>
                    </div>
                </section>

            </>
        )
    }// end render
}// end class

export default connect((state) => ({
        detailInquiry: state.inquiry.detailInquiry,
    }),
    (dispatch) => ({
        InquiryAction: bindActionCreators(inquiryAction, dispatch)
    })
)(InquiryDetailContainer);